import React from 'react'
import { Layout, Icon, Menu, Divider } from 'antd'
import { observer } from 'mobx-react'
import SvgIcon from '../../components/SvgIcon'
import store from '../../store'
import LogoSvg from '../../res/logo.svg'
import UserHeader from './UserHeader'
import './index.scss'

const { Header, Sider, Content } = Layout

@observer
class Home extends React.Component<any, any> {
    public handleLogout = () => {
        // store.authStore.clearUserInfo()
        store.clear()
        this.props.history.push('/login')
    }

    public handleSelectMenu = (props: any) => {
        store.setSelectKeys([props.key])
        store.pageStore.clear()
        this.props.history.push(`/${props.key}`)
    }

    public render() {
        return (
            <Layout className='cms-layout'>
                <Sider
                    trigger={null}
                    collapsible={true}
                    collapsed={store.collapsed}
                >
                    <div className='logo'>
                        <embed src={LogoSvg} />
                    </div>
                    <Menu theme='dark' mode='inline' selectedKeys={store.selectedKeys} onClick={this.handleSelectMenu}>
                        <Menu.Item
                            key='upload'
                            title='Upload'
                        >
                            <SvgIcon icon='upload' />
                            {!store.collapsed &&
                                <span>Upload</span>
                            }
                        </Menu.Item>
                        <Menu.Item
                            key='approve'
                            title='Approve'
                        >
                            <SvgIcon icon='approve' />
                            {!store.collapsed &&
                                <span>Approve</span>
                            }
                        </Menu.Item>
                        <Menu.Item
                            key='search'
                            title='Search'
                        >
                            <SvgIcon icon='search' />
                            {!store.collapsed &&
                                <span>Search</span>
                            }
                        </Menu.Item>
                        <Menu.Item
                            key='graph'
                            title='Knowledge Graph'
                        >
                            <SvgIcon icon='graph' />
                            {!store.collapsed &&
                                <span>Knowledge Graph</span>
                            }
                        </Menu.Item>
                    </Menu>
                </Sider>
                <Layout>
                    <Header>
                        <div className='trigger-wrap'>
                            <Icon
                                className='trigger'
                                type={store.collapsed ? 'menu-unfold' : 'menu-fold'}
                                onClick={() => { store.toggleCollapse() }}
                            />
                        </div>
                        <div className='divider-wrap'>
                            <Divider type='vertical' />
                        </div>
                        <div className='title'>CMS</div>
                        <UserHeader onLogout={this.handleLogout} />
                    </Header>
                    <Content>
                        {this.props.children}
                    </Content>
                </Layout>
            </Layout>
        )
    }
}

export default Home
